import { get, isEmpty } from 'lodash';
import ReactOnRails from 'react-on-rails';

// Step-ordering data and pure helpers, split from steps_order.jsx so that
// non-UI consumers (reducers, analytics) can use them without dragging the
// BYR component tree into every pack that builds the redux Store.

const CONFIGURATIONS = {
  standard: [
    {
      name: 'shingles',
      path: '/shingles',
      title: 'build_your_roof.shingles',
      customizeName: 'shingles',
    },
    {
      name: 'ice-water',
      path: '/ice-water',
      title: 'build_your_roof.ice_water_menu',
      customizeName: 'barriers',
    },
    {
      name: 'underlayment',
      path: '/underlayment',
      title: 'build_your_roof.underlayment_menu',
      customizeName: 'underlayments',
    },
    {
      name: 'starter-shingles',
      path: '/starter-shingles',
      title: 'build_your_roof.starter_shingles',
      customizeName: 'starterShingles',
    },
    {
      name: 'hip-ridge',
      path: '/hip-ridge',
      title: 'build_your_roof.hip_ridge_menu',
      customizeName: 'ridges',
    },
    {
      name: 'ventilation',
      path: '/ventilation',
      title: 'build_your_roof.ventilation',
      customizeName: 'exhaustVentilations',
    },
    {
      name: 'summary',
      path: '/summary',
      title: 'build_your_roof.summary',
      customizeName: null,
    },
  ],
  ice_water_first: [
    {
      name: 'ice-water',
      path: '/ice-water',
      title: 'build_your_roof.ice_water_menu',
      customizeName: 'barriers',
    },
    {
      name: 'underlayment',
      path: '/underlayment',
      title: 'build_your_roof.underlayment_menu',
      customizeName: 'underlayments',
    },
    {
      name: 'starter-shingles',
      path: '/starter-shingles',
      title: 'build_your_roof.starter_shingles',
      customizeName: 'starterShingles',
    },
    {
      name: 'shingles',
      path: '/shingles',
      title: 'build_your_roof.shingles',
      customizeName: 'shingles',
    },
    {
      name: 'ventilation',
      path: '/ventilation',
      title: 'build_your_roof.ventilation',
      customizeName: 'exhaustVentilations',
    },
    {
      name: 'hip-ridge',
      path: '/hip-ridge',
      title: 'build_your_roof.hip_ridge_menu',
      customizeName: 'ridges',
    },
    {
      name: 'summary',
      path: '/summary',
      title: 'build_your_roof.summary',
      customizeName: null,
    },
  ],
};

export const loadVariantFromStore = () => {
  // Load byrConfig.stepOrder

  // We're loading either from customizer state or byr state, depending on where we are
  const store = ReactOnRails.getStore('Store');
  let order;
  order = get(store.getState(), 'byrEditor.configuration.configuration.stepOrder');
  if (isEmpty(order)) {
    order = get(store.getState(), 'byrConfig.stepOrder');
  }

  if (isEmpty(order)) order = 'standard';

  return order;
};

export const StepSetup = ({ variant = loadVariantFromStore() } = {}) => CONFIGURATIONS[variant].map(s => s.name);

export const CustomizeStepSetup = ({ variant = loadVariantFromStore() } = {}) =>
  CONFIGURATIONS[variant].filter(s => s.customizeName).map(s => s.customizeName);

export const StepConfiguration = ({ variant } = { variant: loadVariantFromStore() }) => CONFIGURATIONS[variant];

export const getNextStep = (current, variant = loadVariantFromStore()) => {
  const steps = StepSetup({ variant });
  const nextIndex = steps.indexOf(current) + 1;

  return steps[nextIndex];
};

export const getPrevStep = (current, variant = loadVariantFromStore()) => {
  const steps = StepSetup({ variant });
  const prevIndex = steps.indexOf(current) - 1;

  return steps[prevIndex];
};

export default CONFIGURATIONS;
